import { CinemarkLink } from '@/components/cinemark-link/cinemark-link';
import { dataTestTransformer } from '@/utils/data-test-helper';
import React from 'react';
import userProfileDropdownItemStyles from './user-profile-dropdown-item.module.scss';

type UserProfileDropdownItemProps = {
  dataLinkCategory: string;
  dataLinkName: string;
  icon: React.ReactNode;
  link: string;
  newItem?: boolean;
  onClick?: () => void;
  text: string;
  useAnchor?: boolean;
};

export const UserProfileDropdownItem = ({
  dataLinkCategory,
  dataLinkName,
  icon,
  link,
  newItem,
  onClick,
  text,
  useAnchor,
}: UserProfileDropdownItemProps): React.JSX.Element => {
  return (
    <CinemarkLink className={userProfileDropdownItemStyles['dropdown-link']}
      dataLinkCategory={dataLinkCategory}
      dataLinkName={dataLinkName}
      dataTest={`link-profile-dropdown-${dataTestTransformer(text)}`}
      href={link}
      useAnchor={useAnchor}
      onClick={() => onClick?.()}
    >
      {icon}

      <div className="flex gap-sm items-center">
        <p className="font-bold"
          data-test={`profile-dropdown-${dataTestTransformer(text)}`}
        >
          {text}
        </p>
        {newItem &&
          <span className="text-primary font-bold italic"
            data-test={`profile-dropdown-new-${dataTestTransformer(text)}`}
          >
            NEW
          </span>
        }
      </div>
    </CinemarkLink>
  );
};
